import { render, staticRenderFns } from "./teletareas.vue?vue&type=template&id=646cbde4"
import script from "./teletareas.vue?vue&type=script&lang=js"
export * from "./teletareas.vue?vue&type=script&lang=js"
import style0 from "./teletareas.vue?vue&type=style&index=0&id=646cbde4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports